import { Box, Button, CircularProgress, Typography } from "@mui/material";
import useGuestListStore from "../../../../../../stores/useGuestListStore";
import { GuestListModal, ModalContent } from "./styles";
import useDeleteGuestList from "../../../../../../Hooks/useDeleteGuestList";

const GuestItemDelete = ({ onSuccess }) => {
  const {
    isDeletingGuest,
    setIsDeletingGuest,

    loading,
    setLoading,

    selectedGuest,
    setSelectedGuest,
  } = useGuestListStore();

  const deleteGuestList = useDeleteGuestList();

  const handleClose = () => {
    setIsDeletingGuest(false);
  };

  const handleDelete = () => {
    setLoading(true);
    deleteGuestList(selectedGuest.id)
      .then(() => {
        onSuccess();
        setSelectedGuest(null);
        handleClose();
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <GuestListModal
      open={isDeletingGuest}
      onClose={handleClose}
      disableAutoFocus
      disableRestoreFocus
      disableScrollLock
    >
      <ModalContent
        sx={{ padding: "20px 30px", minWidth: "400px", width: "400px" }}
      >
        <Typography
          fontFamily="Plus Jakarta Sans"
          fontSize={20}
          fontWeight={700}
        >
          Delete Guest?
        </Typography>
        <Typography>
          Are you sure you want to delete&nbsp;
          <Typography fontWeight={700} component="span">
            {selectedGuest?.primary.firstName}&nbsp;
            {selectedGuest?.primary.lastName}&nbsp;
          </Typography>
          from your guest list?
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="text"
            color="primary"
            onClick={handleClose}
            disabled={loading}
            sx={{
              fontSize: 20,
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="secondary" />
            ) : (
              "Back"
            )}
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleDelete}
            disabled={loading}
            sx={{
              fontSize: 20,
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="secondary" />
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </ModalContent>
    </GuestListModal>
  );
};

export default GuestItemDelete;
